import React, { useEffect, useState } from 'react';
import { AlertBanner } from './AlertBanner';
interface Alert {
  id: string;
  type: 'premium' | 'reward' | 'fanclub' | 'behavioral' | 'feature';
  title: string;
  message: string;
  cta: string;
  action?: string;
  avatar?: string;
}
export const AlertSystem: React.FC = () => {
  const [alerts, setAlerts] = useState<Alert[]>([]);
  const [currentAlert, setCurrentAlert] = useState<Alert | null>(null);
  const [showingAlert, setShowingAlert] = useState(false);
  // Sample alerts for demonstration
  const sampleAlerts: Alert[] = [{
    id: '1',
    type: 'premium',
    title: "🔥 Limited Release: Mia's New Story",
    message: "You're one of the few invited to see what she posted last night.",
    cta: 'Unlock Now',
    action: '/premium/mia-khalifa',
    avatar: 'https://uploadthingy.s3.us-west-1.amazonaws.com/jq4Dkth7vgkmZJ8GZmzWDP/bonnyblue.png'
  }, {
    id: '2',
    type: 'reward',
    title: '🎉 You earned 200 LuvTokens!',
    message: 'Thanks for completing the Full Experience Questionnaire.',
    cta: 'View Rewards',
    action: '/rewards'
  }, {
    id: '3',
    type: 'fanclub',
    title: "❤️ You've unlocked Kim Holland's fan club",
    message: 'Enter now to see exclusive content and interact with Kim.',
    cta: 'Join Fan Club',
    action: '/fanclub/kim-holland',
    avatar: 'https://uploadthingy.s3.us-west-1.amazonaws.com/bZ3iVXv5nZEMY6F847weq5/kimholland.png'
  }, {
    id: '4',
    type: 'behavioral',
    title: "👀 You've liked 3 kinky polls this week",
    message: "Want to see Bonnie Blue's roleplay fantasy?",
    cta: 'See Fantasy',
    action: '/polls/kinky/bonnie-blue'
  }, {
    id: '5',
    type: 'feature',
    title: '✨ New Feature: Bond Rituals',
    message: 'Build your emotional connection with custom ritual paths.',
    cta: 'Try It Now',
    action: '/rituals'
  }];
  useEffect(() => {
    // Simulate receiving alerts based on user behavior - changed from 5000ms to 300000ms (5 minutes)
    const timer = setTimeout(() => {
      // Add all sample alerts to the queue
      setAlerts(sampleAlerts);
    }, 300000); // 5 minutes delay before showing any alerts
    return () => clearTimeout(timer);
  }, []);
  useEffect(() => {
    // Display next alert if we have alerts and aren't currently showing one
    if (alerts.length > 0 && !showingAlert) {
      const nextAlert = alerts[0];
      const remainingAlerts = alerts.slice(1);
      setCurrentAlert(nextAlert);
      setAlerts(remainingAlerts);
      setShowingAlert(true);
    }
  }, [alerts, showingAlert]);
  const handleAlertClose = () => {
    setShowingAlert(false);
    setCurrentAlert(null);
  };
  const handleAlertAction = () => {
    // In a real app, this would navigate to the action URL
    console.log('Alert action triggered:', currentAlert?.action);
    // For demonstration, add another alert to the queue after a delay - increased from 10000ms to 30000ms
    setTimeout(() => {
      if (sampleAlerts.length > 0) {
        const randomIndex = Math.floor(Math.random() * sampleAlerts.length);
        const randomAlert = sampleAlerts[randomIndex];
        setAlerts(prev => [...prev, {
          ...randomAlert,
          id: Date.now().toString()
        }]);
      }
    }, 30000); // 30 seconds between alerts
  };
  if (!currentAlert || !showingAlert) return null;
  return <AlertBanner type={currentAlert.type} title={currentAlert.title} message={currentAlert.message} cta={currentAlert.cta} avatar={currentAlert.avatar} onClose={handleAlertClose} onAction={handleAlertAction} displayDuration={15000} // 15 seconds display time
  data-id="element-1264" />;
};